import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-caution-alert-modal',
  standalone: true,
  imports: [],
  templateUrl: './caution-alert-modal.component.html',
  styleUrl: './caution-alert-modal.component.scss'
})
export class CautionAlertModalComponent {
activeModal = inject(NgbActiveModal);
  
  @Input()
  configs: { title?: string, subTitle?: string} = {};
}
